/**
 * Arabic messages for UI-HONEST (./controls.en.ts has the English and the
 * rules). Terms are the glossary's (docs/help/glossary.md): أمر البيع،
 * أمر الشراء، إذن الاستلام، فاتورة المورد، قيد اليومية، إقفال الفترة،
 * القوائم المالية، الأصل الثابت، التحويل المخزني، الجرد، الحركة المخزنية،
 * طريقة تقييم المخزون، قائمة الأسعار، حد الائتمان، الاعتماد، مصفوفة
 * الاعتمادات، الدور الوظيفي، الصلاحية، تطبيق الربط، الجلسة، التحقق بخطوتين،
 * تطبيق المصادقة، رمز الاسترداد، رمز التحقق. Every sentence around them was
 * written by engineering and is in CONTROLS_AR_DRAFT_KEYS for ux-writer.
 *
 * `{{slice}}` and `{{device}}` arrive isolated, so a Latin id or a browser's
 * user-agent string keeps its own direction inside the sentence.
 */
export const controlsAr = {
  pending: {
    salesOrderEditor: "يتوفر مع محرر أوامر البيع ({{slice}}).",
    deliveryFromOrder:
      "يتم التسليم من أمر البيع، مع محرر أوامر البيع ({{slice}}).",
    purchaseEditor: "يتوفر مع محرر أوامر الشراء وأذون الاستلام ({{slice}}).",
    invoiceEditor: "يتوفر مع محرر الفواتير ({{slice}}).",
    paymentEditor: "يتوفر مع محرر الدفعات ({{slice}}).",
    journalEditor: "يتوفر مع محرر قيود اليومية ({{slice}}).",
    quoteEditor: "يتوفر مع محرر عروض الأسعار ({{slice}}).",
    returns: "يتوفر مع الإشعارات الدائنة والمردودات ({{slice}}).",
    dataImport: "يتوفر مع استيراد البيانات ({{slice}}).",
    periodClose: "يتوفر مع إقفال الفترة في نهاية الشهر ({{slice}}).",
    statements: "يتوفر مع شاشات القوائم المالية ({{slice}}).",
    fixedAssets: "يتوفر مع شاشات الأصول الثابتة ({{slice}}).",
    revaluation: "يتوفر مع إعادة تقييم العملات ({{slice}}).",
    stockDocuments: "يتوفر مع التحويلات المخزنية والجرد ({{slice}}).",
    stockMovement: "يتوفر مع إعادة بناء الحركة المخزنية ({{slice}}).",
    valuation: "يتوفر مع شاشات تقييم المخزون ({{slice}}).",
    traceability: "يتوفر مع صفحة التتبع ({{slice}}).",
    manufacturing: "يتوفر مع شاشات التصنيع ({{slice}}).",
    mrp: "تخطيط الاحتياجات غير مبني بعد، ولم يُحسم بعد دخوله في الإطلاق ({{slice}}).",
    pricing: "يتوفر مع أسعار قوائم الأسعار ({{slice}}).",
    creditApproval: "سيُبتّ في حدود الائتمان من خلال الاعتمادات ({{slice}}).",
    people: "يتوفر مع شاشات المستخدمين والأدوار الوظيفية ({{slice}}).",
    approvalDesigner: "يتوفر مع مصمم مصفوفة الاعتمادات ({{slice}}).",
    settingsSave:
      "يتوفر حفظ الإعدادات مع مرحلته في خطة البناء ({{slice}}). وحتى ذلك الحين هي للقراءة فقط.",
    dataExport: "يتوفر مع تصدير بيانات العميل ({{slice}}).",
    packInstall: "يتوفر مع أداة تثبيت الحزم ({{slice}}).",
    packUpgrade: "يتوفر مع ترقية الحزم ({{slice}}).",
    marketplace: "يتوفر مع شاشات سوق الإضافات ({{slice}}).",
    editions: "يتوفر مع الإصدارات ({{slice}}).",
    afterLaunch: "مُخطَّط له بعد الإطلاق ({{slice}}).",
    notScheduled:
      "غير مبني بعد: هو في خارطة الطريق ({{slice}})، لكن لم تُجدول له مرحلة بناء.",
    unplanned:
      "غير مبني بعد، ولا توجد مرحلة بناء مخطط لها. الفجوة مسجلة برقم {{slice}}.",
    taxLedger: "يتوفر مع سجل الضرائب ({{slice}}).",
    vatReturn: "يتوفر مع إقرار ضريبة القيمة المضافة ({{slice}}).",
    statementEngine: "يتوفر مع محرك القوائم المالية ({{slice}}).",
  },
  pager: {
    label: "الصفحات",
    previous: "الصفحة السابقة",
    next: "الصفحة التالية",
    page: "الصفحة {{page}}",
    more: "توجد صفوف أخرى في الصفحة التالية.",
  },
  confirmDialog: {
    working: "جارٍ التنفيذ…",
  },
  sessionControl: {
    revokeTitle: "إنهاء هذه الجلسة؟",
    revokeBody:
      "يُسجَّل خروج الجهاز {{device}} فوراً، ويلزمه تسجيل الدخول من جديد.",
    revokeConfirm: "إنهاء الجلسة",
    revoked: "انتهت الجلسة.",
    revokeAllTitle: "إنهاء كل الجلسات الأخرى؟",
    revokeAllBody_zero: "لا توجد جلسات أخرى. تبقى هذه الجلسة قائمة.",
    revokeAllBody_one:
      "يُسجَّل خروج جلسة أخرى واحدة فوراً. تبقى هذه الجلسة قائمة.",
    revokeAllBody_two:
      "يُسجَّل خروج جلستين أخريين فوراً. تبقى هذه الجلسة قائمة.",
    revokeAllBody_few:
      "يُسجَّل خروج {{count}} جلسات أخرى فوراً. تبقى هذه الجلسة قائمة.",
    revokeAllBody_many:
      "يُسجَّل خروج {{count}} جلسة أخرى فوراً. تبقى هذه الجلسة قائمة.",
    revokeAllBody_other:
      "يُسجَّل خروج {{count}} جلسة أخرى فوراً. تبقى هذه الجلسة قائمة.",
    revokeAllConfirm: "إنهاء الجلسات الأخرى",
    revokedAll_zero: "لم تُنهَ أي جلسة.",
    revokedAll_one: "انتهت جلسة واحدة.",
    revokedAll_two: "انتهت جلستان.",
    revokedAll_few: "انتهت {{count}} جلسات.",
    revokedAll_many: "انتهت {{count}} جلسة.",
    revokedAll_other: "انتهت {{count}} جلسة.",
  },
  mfaSetup: {
    setupTitle: "إعداد التحقق بخطوتين",
    step1:
      "أضف مفتاح الإعداد هذا إلى تطبيق المصادقة، أو افتح الرابط على الهاتف الذي عليه التطبيق.",
    keyLabel: "مفتاح الإعداد",
    openApp: "الفتح في تطبيق المصادقة",
    step2:
      "احفظ رموز الاسترداد هذه في مكان تصل إليه دون هاتفك. يعمل كل رمز مرة واحدة، ولا تُعرض إلا الآن.",
    recoveryCodes: "رموز الاسترداد",
    step3: "أدخل الرمز المكوّن من {{digits}} أرقام الذي يعرضه التطبيق الآن.",
    codeLabel: "الرمز من التطبيق",
    turnOn: "تفعيل",
    starting: "جارٍ البدء…",
    checking: "جارٍ التحقق…",
    enabled: "التحقق بخطوتين مُفعَّل.",
    disableTitle: "إيقاف التحقق بخطوتين",
    disableBody:
      "أدخل الرمز الذي يعرضه تطبيق المصادقة الآن، أو أحد رموز الاسترداد.",
    disableCodeLabel: "الرمز أو رمز الاسترداد",
    turnOff: "إيقاف",
    disabled: "التحقق بخطوتين متوقف.",
  },
  apiClientCreate: {
    title: "تطبيق ربط جديد",
    scopes: "ما يُسمح له به",
    scopesHint:
      "اختر الصلاحيات التي يحصل عليها تطبيق الربط. لا يمكنك منح صلاحية لا تملكها.",
    filter: "تصفية الصلاحيات",
    narrow: "تُعرض أول {{limit}} نتيجة فقط. ضيّق التصفية لترى الباقي.",
    chosen_zero: "لم تُختر أي صلاحية",
    chosen_one: "صلاحية واحدة مختارة",
    chosen_two: "صلاحيتان مختارتان",
    chosen_few: "{{count}} صلاحيات مختارة",
    chosen_many: "{{count}} صلاحية مختارة",
    chosen_other: "{{count}} صلاحية مختارة",
    create: "إنشاء تطبيق الربط",
    creating: "جارٍ الإنشاء…",
    createdTitle: "انسخ السر الآن",
    createdBody:
      "يُعرض هذا السر مرة واحدة فقط. احفظه في مخزن الأسرار لدى التكامل، فلا يستطيع {{product}} عرضه مرة أخرى.",
    secret: "سر تطبيق الربط",
    copy: "نسخ",
    copied: "تم النسخ",
    done: "تم",
  },
  documentActions: {
    newSalesOrder: "أمر بيع جديد",
    newSalesInvoice: "فاتورة جديدة",
    captureSupplierInvoice: "تسجيل فاتورة",
    newPurchaseOrder: "أمر شراء جديد",
    newGoodsReceipt: "إذن استلام جديد",
    newPayment: "دفعة جديدة",
    newJournalEntry: "قيد يومية جديد",
    newQuotation: "عرض سعر جديد",
    newBom: "قائمة مكونات جديدة",
    runMrp: "تشغيل تخطيط الاحتياجات",
    newInspection: "فحص جديد",
    submit: "إرسال للاعتماد",
    post: "ترحيل",
    reverse: "عكس القيد",
  },
  notificationActions: {
    allRead: "تم تحديد كل الإشعارات مقروءة.",
  },
  notAvailable: {
    title: "غير متاح بعد",
    navTag: "غير متاح بعد",
    noFigures: "لا شيء في هذه الصفحة يعمل بعد، لذلك لا تعرض أي أرقام.",
    reportBuilder:
      "منشئ التقارير لا يشغّل أي تقرير بعد. لا يمكن هنا تصميم التقارير أو تشغيلها أو جدولتها أو تصديرها.",
    pivot:
      "عارض التقارير المحورية لا يحسب أي جدول محوري بعد. لا يمكن هنا إنشاء الجداول المحورية أو فتحها.",
    dashboardBuilder:
      "منشئ لوحات المؤشرات لا يبني أي لوحة بعد. لا يمكن هنا إنشاء اللوحات أو إضافة عناصر إليها أو مشاركتها.",
  },
};

/** Every key of one namespace, a plural listed once by its base. */
function keysOf(namespace: keyof typeof controlsAr): string[] {
  const base = Object.keys(controlsAr[namespace]).map((k) =>
    k.replace(/_(zero|one|two|few|many|other)$/, ""),
  );
  return [...new Set(base)].map((k) => `${namespace}.${k}`);
}

/**
 * Every key above whose Arabic is not a glossary term word for word: all of
 * them, written by engineering. ./ar.ts adds this list to AR_DRAFT_KEYS.
 */
export const CONTROLS_AR_DRAFT_KEYS: readonly string[] = (
  Object.keys(controlsAr) as Array<keyof typeof controlsAr>
).flatMap(keysOf);
